// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import elTableInfiniteScroll from 'el-table-infinite-scroll';

Vue.use(elTableInfiniteScroll);


Vue.config.productionTip = false;

// import plTable from 'pl-table'
import 'pl-table/themes/index.css' // 引入样式（必须引入)，vuecli3.0不需要配置，cli2.0请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
// import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
// Vue.use(plTable);

import './style/index.scss'; // global css

import store from './store';

import '@/permission'; // permission control

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// 引入 v-contextmenu 和其样式文件
import VContextMenu from 'v-contextmenu';
import 'v-contextmenu/dist/index.css';
Vue.use(VueQuillEditor);

// main.js
import XEUtils from 'xe-utils'
if (!XEUtils.toValueString) {
  XEUtils.toValueString = function(obj) {
    return obj != null ? obj.toString() : ''
  }
}
// import Sortable from 'sortablejs';
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VxeUIAll)
// Vue.use(Sortable)
Vue.use(VxeUITable)
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// import { VueDraggable } from 'vue-draggable-plus'; // 引入 VueDraggable

// 全局注册 VueDraggable 组件
// Vue.component('VueDraggable', draggable);
Vue.use(ViewUI);
// 导出excel
import Blob from '@/excel/Blob.js'
import export2Excel from '@/excel/Export2Excel.js'

import 'babel-polyfill';

import '@/utils/dialogdrag.js';
import '@/utils/table-sticky.js';
import draggable from 'vuedraggable'; // 引入 VueDraggable
// 全局注册 VueDraggable 组件
Vue.component('VueDraggable', draggable);
Vue.use(ElementUI);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import '@/utils/onStorage.js'
import dateFormat from '@/utils/dateFormat.js'

// 组件引入
import showList from "@/components/showList";
Vue.component('showList', showList)

Vue.use(VContextMenu);

import 'devextreme/dist/css/dx.material.blue.light.compact.css';

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js